import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import * as TRANSLATIONS_EN from "./locales/en_bajaj.json"; //for Bajaj
// import * as TRANSLATIONS_EN from "./locales/en.json";           // for product
import * as TRANSLATIONS_ES from "./locales/es.json";
import * as TRANSLATIONS_ML from "./locales/ml.json";
import * as TRANSLATIONS_THAI from "./locales/thai.json";
export var AVAILABLE_LANGUAGES = [{
        code: "en",
        label: "English"
    }, {
        code: "es",
        label: "Spanish"
    }, {
        code: "ml",
        label: "Malay"
    }, {
        code: "thi",
        label: "Thai"
    }];
var selectedLanguage = JSON.parse(localStorage.getItem("SelectedLanguage") ? localStorage.getItem("SelectedLanguage") : null);
var currentLanguage = selectedLanguage ? selectedLanguage : "English - United States";
i18n.use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: "English",
    lng: currentLanguage,
    detection: {
        // order and from where user language should be detected
        order: ["querystring", "navigator"],
        // keys or params to lookup language from
        lookupQuerystring: "lng"
    },
    debug: false,
    resources: {
        English: {
            translations: _objectSpread({}, TRANSLATIONS_EN.default)
        },
        Spanish: {
            translations: _objectSpread({}, TRANSLATIONS_ES.default)
        },
        Malay: {
            translations: _objectSpread({}, TRANSLATIONS_ML.default)
        },
        Thai: {
            translations: _objectSpread({}, TRANSLATIONS_THAI.default)
        }
    },
    nsSeparator: false,
    ns: ["translations"],
    defaultNS: "translations"
});
i18n.languages = ["English", "Spanish", "Malay", "Thai"];
export default i18n;
